import { booleanAttribute, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyI18NModule } from '@vendasta/galaxy/i18n';
import { GalaxyFrequencyPipe } from './frequency.pipe';
import { Form, Frequency } from './interface';

@Component({
  selector: 'glxy-frequency',
  templateUrl: './frequency.component.html',
  styleUrls: ['./frequency.component.scss'],
  host: { class: 'glxy-frequency', '[class.glxy-frequency--inline]': 'inline()' },
  imports: [GalaxyFrequencyPipe, TranslateModule, GalaxyI18NModule],
})
export class GalaxyFrequencyComponent {
  readonly value = input.required<string>();
  /**
   * If you want the currency code to match the text sizing of the frequency, provide it separately from the value.
   */
  readonly currencyCode = input<string>();
  readonly frequency = input<Frequency>(Frequency.ONE_TIME);
  readonly form = input<Form | 'short' | 'long' | 'verbose'>(Form.SHORT);
  readonly size = input<'regular' | 'large'>('regular');
  readonly align = input<'end' | 'start' | 'center'>('end');
  readonly allowCustomStyling = input(false, { transform: booleanAttribute });
  /** Flows the price and frequency as inline text, so the component can sit inside a sentence. */
  readonly inline = input(false, { transform: booleanAttribute });

  /* Callers pass capitalized values through form controls, so compare case-insensitively. */
  protected readonly isAlignStart = computed(() => this.align().toLowerCase() === 'start');
  protected readonly isLarge = computed(() => this.size().toLowerCase() === 'large');
  protected readonly isVerbose = computed(() => this.form().toLowerCase() === Form.VERBOSE);
}
